<template>
  <div>
    <table>
      <thead>
        <tr class="header-of-page">
          <div class="d-flex p-3">
            <div
              class="logo"
              v-if="
                invoiceDetails.fatura_id != null ||
                invoiceDetails.fatura_id != undefined
              "
            >
              <!-- <img
                :src="require('../images/logo.png')"
                class="img-fluid"
                alt=""
              /> -->
            </div>
            <div
              class="center"
              :style="invoiceDetails.fatura_id ? 'width: 30%;' : 'width: 50%;'"
            >
              <img :src="img" class="logo" alt="" />
            </div>
            <div class="content" v-if="invoiceDetails != null">
              <div class="row pb-1" v-if="title.includes('مبيعات')">
                <div class="col-2 title">العميل</div>
                <div class="col-10 title name">
                  {{ invoiceDetails.customer.name }}
                </div>
              </div>
              <div class="row pb-1" v-if="title.includes('شراء')">
                <div class="col-2 title">المورد</div>
                <div class="col-10 title name">
                  {{ invoiceDetails.supplier.name }}
                </div>
              </div>
              <div class="row pb-1" v-if="title.includes('مبيعات')">
                <div class="col-2 title">العنوان</div>
                <div class="col-7 title">
                  {{ invoiceDetails.customer.address }}
                </div>
              </div>
              <div class="row pb-1" v-if="title.includes('شراء')">
                <div class="col-2 title">العنوان</div>
                <div class="col-7 title">
                  {{ invoiceDetails.supplier.address }}
                </div>
              </div>
              <div class="row pb-1">
                <div class="col-2 title">الهاتف</div>
                <div class="col-10 title" v-if="title.includes('مبيعات')">
                  {{ invoiceDetails.customer.phone }}
                </div>
                <div class="col-10 title" v-if="title.includes('شراء')">
                  {{ invoiceDetails.supplier.phone }}
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex border" v-if="invoiceDetails != null">
            <div class="first">
              <p>
                {{
                  invoiceDetails.created_at
                    | moment("dddd | Do / MM / YYYY | h:mm A")
                }}
              </p>
              <p class="mr-auto icon"><i class="fas fa-circle"></i></p>
            </div>
            <div class="second">
              <p>
                فاتورة {{ title }} #
                {{ invoiceDetails.id }}
              </p>
              <p class="mr-auto icon"><i class="fas fa-circle"></i></p>
            </div>
            <div class="third" v-if="invoiceDetails.inventory != undefined">
              <p>اداره المخازن - {{ invoiceDetails.inventory.name }}</p>
            </div>
          </div>
        </tr>
      </thead>
      <tbody class="bg-w" v-if="invoiceDetails != null">
        <tr>
          <table class="table" v-if="invoiceDetails != null">
            <colgroup>
              <col name="el-table_3_column_11" width="5%" />
              <col name="el-table_3_column_12" width="60%" />
              <col name="el-table_3_column_13" width="10%" />
              <col name="el-table_3_column_14" width="10%" />
              <col name="el-table_3_column_17" width="15%" />
            </colgroup>
            <thead>
              <tr>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_11 is-leaf"
                >
                  <div class="text-center">#</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_12 is-leaf"
                >
                  <div class="pr-1">المنتج</div>
                </th>
                <th
                  colspan="2"
                  rowspan="1"
                  class="el-table_3_column_13 is-leaf"
                >
                  <div class="text-center">الكمية</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_14 is-leaf"
                >
                  <div class="text-center">السعر</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_17 is-leaf"
                >
                  <div class="text-center">اجمالي</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class=""
                v-for="(item, index) in invoiceDetails.products"
                :key="index"
              >
                <template v-if="invoiceType === 'sales'">
                  <template v-if="item.pivot.qty - item.pivot.returned_qty > 0">
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_11 is-leaf"
                    >
                      <div class="bg-Lightgray align-center">
                        {{ index + 1 }}
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_12 is-leaf"
                    >
                      {{ item.name }}
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf text-center"
                    >
                      <div
                        class="bg-Lightgray align-center"
                        v-if="Number(item.pivot.unit_type) === 2"
                      >
                        {{
                          Number(item.pivot.qty) -
                          Number(item.pivot.returned_qty)
                        }}
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf text-center"
                    >
                      <div
                        class="bg-Lightgray align-center"
                        v-if="Number(item.pivot.unit_type) === 1"
                      >
                        {{
                          Number(item.pivot.qty) -
                          Number(item.pivot.returned_qty)
                        }}
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_14 is-leaf text-center"
                      style="text-align: center"
                    >
                      <div v-if="title.includes('مبيعات')">
                        {{ item.pivot.sale_price }}
                      </div>
                      <div v-if="title.includes('شراء')">
                        {{ item.pivot.buy_cost }}
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf text-center"
                      style="text-align: center"
                    >
                      <div v-if="title.includes('مبيعات')">
                        {{
                          (Number(item.pivot.qty) -
                            Number(item.pivot.returned_qty)) *
                          Number(item.pivot.sale_price)
                        }}
                      </div>
                      <div v-if="title.includes('شراء')">
                        {{
                          (Number(item.pivot.qty) -
                            Number(item.pivot.returned_qty)) *
                          Number(item.pivot.buy_cost)
                        }}
                      </div>
                    </td>
                  </template>
                </template>
                <template v-else>
                  <td
                    colspan="1"
                    rowspan="1"
                    class="el-table_3_column_11 is-leaf"
                  >
                    <div class="bg-Lightgray align-center">
                      {{ index + 1 }}
                    </div>
                  </td>
                  <td
                    colspan="1"
                    rowspan="1"
                    class="el-table_3_column_12 is-leaf"
                  >
                    {{ item.name }}
                  </td>
                  <td
                    colspan="1"
                    rowspan="1"
                    class="el-table_3_column_13 is-leaf text-center"
                  >
                    <div
                      class="bg-Lightgray align-center"
                      v-if="Number(item.pivot.unit_type) === 2"
                    >
                      {{ item.pivot.qty }}
                    </div>
                  </td>
                  <td
                    colspan="1"
                    rowspan="1"
                    class="el-table_3_column_13 is-leaf text-center"
                  >
                    <div
                      class="bg-Lightgray align-center"
                      v-if="Number(item.pivot.unit_type) === 1"
                    >
                      {{ item.pivot.qty }}
                    </div>
                  </td>
                  <td
                    colspan="1"
                    rowspan="1"
                    class="el-table_3_column_14 is-leaf text-center"
                    style="text-align: center"
                  >
                    <div v-if="title.includes('مبيعات')">
                      {{ item.pivot.sale_price }}
                    </div>
                    <div v-if="title.includes('شراء')">
                      {{ item.pivot.buy_cost }}
                    </div>
                  </td>
                  <td
                    colspan="1"
                    rowspan="1"
                    class="el-table_3_column_15 is-leaf text-center"
                    style="text-align: center"
                  >
                    <div v-if="title.includes('مبيعات')">
                      {{
                        Number(item.pivot.qty) * Number(item.pivot.sale_price)
                      }}
                    </div>
                    <div v-if="title.includes('شراء')">
                      {{ Number(item.pivot.qty) * Number(item.pivot.buy_cost) }}
                    </div>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
          <el-row justify="between" class="full-width">
            <el-col :span="6">
              <table class="total-qty">
                <tr>
                  <td style="white-space: nowrap">عدد الأصناف الرئسية</td>
                  <td width="15%">{{ totalMainQty }}</td>
                </tr>
                <tr>
                  <td style="white-space: nowrap">عدد الأصناف الفرعية</td>
                  <td width="15%">{{ totalSubQty }}</td>
                </tr>
              </table>
            </el-col>
            <el-col :span="6" style="margin-right: auto">
              <table class="paymentDitals">
                <tr>
                  <td style="white-space: nowrap">رصيد سابق</td>
                  <td v-if="invoiceDetails.paied_amount != undefined">
                    <div v-if="title.includes('مبيعات')">
                      {{
                        numberToFixed(
                          numberToFixed(
                            Number(invoiceDetails.customer.balance) +
                              Number(invoiceDetails.customer.account) +
                              Number(invoiceDetails.paied_amount)
                          ) -
                            numberToFixed(
                              Number(invoiceDetails.total_cost) -
                                Number(invoiceDetails.returned_amount) -
                                Number(invoiceDetails.discount)
                            )
                        )
                      }}
                    </div>
                    <div v-if="title.includes('شراء')">
                      {{
                        numberToFixed(
                          numberToFixed(
                            Number(invoiceDetails.supplier.balance) +
                              Number(invoiceDetails.supplier.account) +
                              Number(invoiceDetails.paied_amount)
                          ) -
                            numberToFixed(
                              Number(invoiceDetails.total_cost) -
                                Number(invoiceDetails.discount)
                            )
                        )
                      }}
                    </div>
                  </td>

                  <td v-else>
                    <div v-if="title.includes('مبيعات')">
                      {{
                        numberToFixed(
                          numberToFixed(
                            Number(invoiceDetails.customer.balance) +
                              Number(invoiceDetails.customer.account)
                          ) -
                            numberToFixed(
                              Number(invoiceDetails.total_cost) -
                                Number(invoiceDetails.discount)
                            )
                        )
                      }}
                    </div>
                    <div v-if="title.includes('شراء')">
                      {{
                        numberToFixed(
                          numberToFixed(
                            Number(invoiceDetails.supplier.balance) +
                              Number(invoiceDetails.supplier.account)
                          ) -
                            numberToFixed(
                              Number(invoiceDetails.total_cost) -
                                Number(invoiceDetails.discount)
                            )
                        )
                      }}
                    </div>
                  </td>
                </tr>
                <template v-if="invoiceDetails.discount > 0">
                  <tr>
                    <td style="white-space: nowrap">الفاتورة قبل الخصم</td>
                    <td v-if="invoiceType === 'sales'">
                      {{
                        Number(invoiceDetails.total_cost) -
                        Number(invoiceDetails.returned_amount)
                      }}
                    </td>
                    <td v-else>{{ invoiceDetails.total_cost }}</td>
                  </tr>
                  <tr>
                    <td>الخصم</td>
                    <td>{{ invoiceDetails.discount }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">الفاتورة بعد الخصم</td>
                    <td v-if="invoiceType === 'sales'">
                      {{
                        Number(invoiceDetails.total_cost) -
                        Number(invoiceDetails.returned_amount) -
                        Number(invoiceDetails.discount)
                      }}
                    </td>
                    <td v-else>
                      {{
                        Number(invoiceDetails.total_cost) -
                        Number(invoiceDetails.discount)
                      }}
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td>الفاتورة</td>
                    <td>
                      <template v-if="invoiceType === 'sales'">
                        {{
                          Number(invoiceDetails.total_cost) -
                          Number(invoiceDetails.returned_amount) -
                          Number(invoiceDetails.discount)
                        }}
                      </template>
                      <template v-else>
                        {{
                          Number(invoiceDetails.total_cost) -
                          Number(invoiceDetails.discount)
                        }}
                      </template>
                    </td>
                  </tr>
                </template>

                <tr
                  v-if="
                    invoiceDetails.paied_amount != undefined &&
                    invoiceDetails.paied_amount
                  "
                >
                  <td>المدفوع</td>
                  <td>{{ invoiceDetails.paied_amount }}</td>
                </tr>
                <tr>
                  <td>الرصيد</td>
                  <td>
                    <div v-if="title.includes('مبيعات')">
                      {{
                        numberToFixed(
                          Number(invoiceDetails.customer.balance) +
                            Number(invoiceDetails.customer.account)
                        )
                      }}
                    </div>
                    <div v-if="title.includes('شراء')">
                      {{
                        numberToFixed(
                          Number(invoiceDetails.supplier.balance) +
                            Number(invoiceDetails.supplier.account)
                        )
                      }}
                    </div>
                  </td>
                </tr>
              </table>
            </el-col>
          </el-row>
          <table class="result">
            <tr>
              <td v-if="title.includes('مبيعات')">
                {{
                  Number(invoiceDetails.customer.balance) > 0 ? "مدين" : "دائن"
                }}
              </td>
              <td v-if="title.includes('شراء')">
                {{
                  Number(invoiceDetails.supplier.balance) > 0 ? "دائن" : "مدين"
                }}
              </td>
              <td>
                <div v-if="title.includes('مبيعات')">
                  {{
                    numberToString(
                      Number(invoiceDetails.customer.balance) +
                        Number(invoiceDetails.customer.account)
                    ) +
                    " " +
                    "فقط لا غير "
                  }}
                </div>
                <div v-if="title.includes('شراء')">
                  {{
                    numberToString(
                      Number(invoiceDetails.supplier.balance) +
                        Number(invoiceDetails.supplier.account)
                    ) +
                    " " +
                    "فقط لا غير "
                  }}
                </div>
              </td>
            </tr>
          </table>
        </tr>
      </tbody>
      <tfoot>
        <tr class="footer-of-page" v-if="invoiceDetails.inventory != undefined">
          <p>
            برجاء مراجعه استلام البضاعه قبل مغادره المندوب للشكاوي الاتصال
            {{ invoiceDetails.inventory.phone }}
          </p>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
// import { ipcRenderer } from "electron";
// window.ipcRenderer = ipcRenderer;
var writtenNumber = require("written-number");
writtenNumber.defaults.lang = "ar";
export default {
  props: [
    "invoiceDetails",
    "totalMainQty",
    "totalSubQty",
    "title",
    "invoiceType",
    "img",
  ],

  methods: {
    numberToFixed(number) {
      let num = Number(number);
      return Math.floor(num * 100) / 100;
    },
    numberToString(number) {
      if (number < 0) {
        number = number * -1;
      }
      return writtenNumber(number);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_color.scss";
@import url("https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700&family=Open+Sans:wght@400;600;700&display=swap");
body {
  font-family: cairo !important;
}
.bg-w {
  margin: 0;
  padding: 0;
  // padding-bottom: 40px;
  height: calc(100% - 270px);
}
.header-of-page {
  background-color: #f7f8fa;
  .p-3 {
    padding: 22px 18px !important;
  }
  .logo {
    width: 18%;
    .img-fluid {
      width: 56px;
      height: 56px;
    }
  }
  .center {
    .logo {
      height: 47px;
      width: 75px;
    }
  }
  .content {
    width: 50%;
    .title {
      color: #000000;
      font-family: Cairo;
      font-size: 10px;
      font-weight: bold;
      letter-spacing: 0;
    }
  }
  .border {
    width: 100%;
    padding: 13px 8px;
    border-top: 2px solid #fff;
    .first,
    .second {
      color: #000000;
      font-family: Cairo;
      font-size: 10px;
      font-weight: 600;
      display: flex;
      align-items: center;
      margin-left: 22px;
      .icon {
        font-size: 7px;
        color: #d8d8d8;
      }
      P {
        text-align: center !important;
        width: 96%;
      }
    }
    .first {
      width: 45%;
    }
    .second {
      width: 35%;
    }
    .third {
      width: 25%;
      color: #000000;
      font-family: Cairo;
      font-size: 10px;
      font-weight: 600;
      display: flex;
      align-items: center;
      .icon {
        font-size: 4px;
        color: #d8d8d8;
      }
    }
  }
}
.bg-whi {
  width: 100%;
  height: 21vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .firstDiv {
    background-color: #f7f8fa;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    width: 95%;
    height: 19vh;
    .thead {
      background-color: #f2f3f5;
      height: 8vh;
      width: 100%;
      color: #000000;
      font-family: Cairo;
      font-size: 10px;
      font-weight: bold;
    }
    .tbody {
      background-color: $subColor;
      height: 8vh;
      width: 100%;
      color: #000000;
      font-family: Cairo;
      font-size: 12px;
      font-weight: bold;
    }
    .cell {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.footer-of-page {
  text-align: center;
  width: 100%;
  // position: fixed;
  // bottom: 0;
  // height: 28px;
  background: #f7f8fa;
  p {
    font-family: Cairo;
    font-size: 8px;
  }
}
table {
  width: 100%;
  border: none;
  caption-side: bottom;
  thead tr {
    border: none !important;
  }
  tr {
    border: none !important;
  }
}
.table {
  margin: 1rem auto;
  width: 95%;
  border: none;
  border-collapse: collapse;
  border-bottom: none !important;
  font-size: 13px !important;
  thead {
    padding: 10px;
    border: none;
    tr {
      th {
        padding: 7px;
        border: 1px solid #000;
        .cell {
          font-weight: normal !important;
          color: #000000;
          font-family: Cairo;
          font-size: 12px !important;
          font-weight: 600;
          display: flex;
        }
      }
    }
  }
  tbody {
    border: none;
    break-after: avoid;
    tr {
      td {
        text-align: right;
        padding: 3px;
        margin-bottom: 0.5rem;
        border: 1px solid #000;
        .cell {
          font-weight: normal !important;
          height: 70px;
          color: #000000;
          font-family: Cairo;
          font-size: 10px;
          font-weight: 600;
          display: flex !important;
          &.bg-gray {
            background-color: #e5e5e5;
          }
          &.bg-Lightgray {
            background-color: #f7f8fa;
            border: 1px solid #fff;
          }
        }
      }
    }
  }
  tfoot {
    td {
      border: 1px solid #000 !important;
    }
  }
  tr,
  td {
    border: none;
    line-height: 1.7;
    text-align: right;
  }
  tfoot {
    border: none;
    tr {
      height: 30px;
      border: none;
    }
  }
}
.pb-2 {
  padding-bottom: 1rem;
}
.text-center {
  text-align: center;
}
.align-center {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Open Sans" !important;
}
.d-none {
  display: none;
}
.mt {
  margin-top: 182px;
}
.onlyAlign {
  display: flex;
  align-items: center;
  padding-right: 0.5rem;
}
.pb-1 {
  margin-bottom: 0.5rem;
}
.mr-auto {
  margin-right: auto;
}
.pr-1 {
  padding-right: 0.5rem;
}
.d-flex {
  display: flex !important;
}
.paymentDitals {
  border-collapse: collapse;
  background-color: white;
  td {
    border: 1px solid;
    text-align: center;
    &:first-of-type {
      background-color: #e0e0e0;
    }
  }
}
.total-qty {
  border-collapse: collapse;
  background-color: white;
  margin-right: auto;
  td {
    border: 1px solid;
    text-align: center;
    &:first-of-type {
      background-color: #e0e0e0;
    }
  }
}
.result {
  width: 95%;
  margin: 20px auto;
  border-collapse: collapse;
  background-color: white;
  td {
    border: 1px solid;
    text-align: center;
    &:first-of-type {
      background-color: #e0e0e0;
    }
  }
}
.full-width {
  width: 100% !important;
  margin-left: 0;
  margin-right: 0;
  padding: 0 15px;
  font-size: 14px;
}
</style>
